import { TimeInterval } from 'models/subscriptionsApi'

import { Currency, DAYS_IN_MONTH, DAYS_IN_WEEK } from 'root-constants'

const DAYS_IN_YEAR = 365

const DAYS_IN_INTERVAL = {
  [TimeInterval.DAY]: 1,
  [TimeInterval.WEEK]: DAYS_IN_WEEK,
  [TimeInterval.MONTH]: DAYS_IN_MONTH,
  [TimeInterval.YEAR]: DAYS_IN_YEAR,
}

export const formatAmount = (amount: number, currency: string): string => {
  if (currency.toLowerCase() === Currency.KRW) {
    return `${Math.trunc(amount)}`
  }

  return amount.toFixed(2)
}

export const getDailyPrice = (
  price: number,
  interval: string,
  intervalCount: number,
): number => {
  const days = (DAYS_IN_INTERVAL[interval] || 0) * intervalCount

  return days ? price / days : 0
}

export const roundToNinetyNineCents = (price: number): number =>
  price ? Math.ceil(price) - 0.01 : price
